module.exports = __webpack_public_path__ + "img/icon_3_10.dc9a3836.png";